import { useId, useRef, type ReactNode, type RefObject } from 'react'
import { useModalDialog } from '../hooks/useModalDialog'

export default function VehicleActionDialog({ title, children, confirmLabel, onConfirm, onClose, returnFocus }: {
  title: string; children: ReactNode; confirmLabel: string; onConfirm: () => void; onClose: () => void; returnFocus?: RefObject<HTMLElement>
}) {
  const id = useId()
  const cancel = useRef<HTMLButtonElement>(null)
  const modal = useModalDialog({ onClose, initialFocus: cancel, returnFocus })
  return <dialog {...modal} tabIndex={-1} aria-modal="true" aria-labelledby={id} className="vehicle-dialog fixed inset-0 m-0 w-full max-w-none max-h-none overflow-hidden border-0 bg-transparent p-0 backdrop:bg-slate-950/60">
    <div className="flex h-full items-center justify-center p-3">
      <div className="flex max-h-full w-full max-w-xl flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 text-slate-900 shadow-2xl dark:border-slate-700 dark:bg-slate-900 dark:text-white">
        <h2 id={id} className="shrink-0 text-lg font-bold">{title}</h2>
        <div className="my-4 min-h-0 overflow-y-auto text-sm leading-relaxed">{children}</div>
        <div className="flex shrink-0 flex-wrap justify-end gap-3">
          <button ref={cancel} type="button" onClick={onClose} className="rounded-xl border border-slate-300 px-4 py-2.5 dark:border-slate-600">Revenir à l’édition</button>
          <button type="button" onClick={onConfirm} className="rounded-xl bg-orange-700 px-4 py-2.5 font-semibold text-white hover:bg-orange-800">{confirmLabel}</button>
        </div>
      </div>
    </div>
  </dialog>
}
